import React from "react";
import "./Footer.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import logo from "../../../assets/images/logo.png";
import facbook from "../../../assets/icons/facebook-icon.svg";
import whatsapp from "../../../assets/icons/whatsapp-icon.svg";
import phone from "../../../assets/icons/phone-icon.svg";
import mail from "../../../assets/icons/mail-icon.svg";

function Footer() {
  const { t } = useTranslation("layout");
  return (
    <footer>
      <div className="container">
        <picture className="footer-logo">
          <img loading="lazy" src={logo} alt="" />
        </picture>
        <div className="footer-links-wrapper">
          <div>
            <h4> {t("footer.quick-links")}</h4>
            <div className="footer-links">
              <Link className="footer-link" to="/">
                {t("footer.home")}
              </Link>
              <Link className="footer-link" to="/about">
                {t("footer.about")}
              </Link>
              <Link className="footer-link" to="/reference">
                {t("footer.refrences")}
              </Link>
              <Link className="footer-link" to="/products">
                {t("footer.products")}
              </Link>
              <Link className="footer-link" to="/services">
                {t("footer.services")}
              </Link>
              <Link className="footer-link" to="/news">
                {t("footer.news")}
              </Link>
              <Link className="footer-link" to="/partners">
                {t("footer.partners")}
              </Link>
            </div>
          </div>
          <div>
            <h4>{t("footer.contact-us")}</h4>
            <div className="contact-methods-box">
              <div className="contact-method">
                <picture>
                  <img loading="lazy" src={mail} alt="" srcset="" />
                </picture>
                <a href="mailto:">info@alnabaatech.com.ly</a>
              </div>
              <div className="contact-method">
                <picture>
                  <img loading="lazy" src={whatsapp} alt="whatsapp" />
                </picture>
                <a
                  href="https://wa.me/218914451288"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  00218914451288
                </a>
              </div>
              <div className="contact-method">
                <picture>
                  <img loading="lazy" src={phone} alt="phone" />
                </picture>
                <a href="tel:+218944415799">00218944415799</a>
              </div>
              <div className="contact-method">
                <picture>
                  <img loading="lazy" src={facbook} alt="" srcset="" />
                </picture>
                <a href="https://www.facebook.com/profile.php?id=100057310905858&mibextid=wwXIfr">
                  شركة النبع للتقنية
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
